/* DGA nieuwe huisstijl: USP's in de groene balk bovenaan op mobiel, zoals bij Coolblue.
   Op mobiel staat er steeds één USP in beeld. Om de 4 seconden schuift de huidige USP naar links weg en komt de
   volgende in 0,5 seconde vanuit rechts binnen. Na de laatste komt de eerste weer vanuit rechts (geen terugspoelen).
   - alleen op mobiel: de desktopbalk (alle USP's naast elkaar) blijft ongewijzigd
   - pauzeert als het tabblad niet zichtbaar is
   - bij 'beweging verminderen' wisselt de tekst zonder schuifbeweging
   Wordt op alle pagina's geladen (snippets/meta-tags.liquid). */
(function(){
  var INTERVAL=4000,DUR=500;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(ss){
    if(ss.dataset.pgUsp)return;
    var slider=ss.querySelector('.slider');if(!slider)return;
    var slides=[].slice.call(slider.children).filter(function(s){return s.nodeType===1&&/slide/.test(s.className);});
    if(slides.length<2)return;
    ss.dataset.pgUsp='1';
    var h=slides[0].offsetHeight||30;
    slider.style.setProperty('overflow','hidden','important');
    slider.style.setProperty('scroll-snap-type','none','important');
    slider.style.position='relative';slider.style.display='block';slider.style.height=h+'px';
    slides.forEach(function(s,i){
      s.style.position='absolute';s.style.left='0';s.style.top='0';s.style.width='100%';s.style.height='100%';s.style.margin='0';
      s.style.transform=i?'translateX(100%)':'translateX(0)';
      s.setAttribute('aria-hidden',i?'true':'false');
    });
    var idx=0;
    function next(){
      if(document.hidden||!slider.offsetParent)return; /* tabblad verborgen of desktop: niets doen */
      var cur=slides[idx],n=(idx+1)%slides.length,nx=slides[n];
      /* De volgende eerst zonder animatie rechts klaarzetten */
      nx.style.transition='none';nx.style.transform='translateX(100%)';void nx.offsetWidth;
      var t=reduce?'none':'transform '+DUR+'ms cubic-bezier(.45,0,.2,1)';
      cur.style.transition=t;nx.style.transition=t;
      cur.style.transform='translateX(-100%)';nx.style.transform='translateX(0)';
      cur.setAttribute('aria-hidden','true');nx.setAttribute('aria-hidden','false');
      idx=n;
    }
    setInterval(next,INTERVAL);
  }
  function run(){[].forEach.call(document.querySelectorAll('.announcement-bar-section slideshow-component'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
